'use client';
import React, { useState, useEffect } from 'react';
import { fetchBrands } from '@/lib/supabase/dinauto-service';

const FALLBACK_BRANDS = ['Toyota', 'Kia', 'Hyundai', 'Fiat', 'Nissan', 'Ford', 'VW', 'Peugeot', 'Honda', 'Volvo', 'BMW', 'Mercedes'];

export default function BrandsStrip() {
  const [brands, setBrands] = useState<string[]>(FALLBACK_BRANDS);

  useEffect(() => {
    fetchBrands().then((data) => {
      if (data.length > 0) setBrands(data.map((b) => b.name));
    });
  }, []);

  return (
    <section className="py-8 bg-foreground border-t border-white/10">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-3 mb-6">
          <span className="text-white/30 text-xs font-bold uppercase tracking-widest">Our Fleet Brands</span>
          <div className="flex-1 h-px bg-white/10" />
        </div>
        <div className="flex flex-wrap gap-x-8 gap-y-3">
          {brands?.map((brand) => (
            <span
              key={`brand-strip-${brand}`}
              className="text-white/40 font-black text-sm uppercase tracking-widest hover:text-primary transition-colors cursor-default"
              style={{ fontWeight: 900 }}
            >
              {brand}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}